<template>
    <div class="card">
        <div class="card-header">
            Novas vendas hoje
        </div>

        <div class="card-body">
            <div class="text-center">
                <h2>R$ {{values.sales}} </h2>

                <ul class="text-left list-unstyled" style="font-size: 0.9rem;" >
                    <li>{{values.count}} Novas vendas</li>
                    <li>R$ {{values.avista}} a vista</li>
                    <li>R$ {{values.aprazo}} a prazo</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'vwNewSales',
    data(){
        return {
            values : {
                sales: 0,
                count: 0,
                avista: 0,
                aprazo: 0
            }
        }
    },
    computed: {
        getToken(){
            return this.$store.getters.getToken
        }
    },
    methods: {
        getData: function(){
            fetch(server + 'gethomesalesinfo?token='+this.getToken, {
                method: 'GET',
            })
                .then(response => (response.json()))
                .then(responseJSON => {
                    
                    let data = responseJSON.data

                    if(data.length > 0){
                        let sales = 0
                        let count = 0
                        let avista = 0
                        let aprazo = 0

                        data.forEach(element => {
                            count = parseInt(count) + parseInt(element.VENDAS)
                            sales = parseFloat(sales) + parseFloat(element.TOTAL)

                            if(element.AVISTA == 'S'){
                                avista = parseFloat(avista) + parseFloat(element.TOTAL)
                            }else{
                                aprazo = parseFloat(aprazo) + parseFloat(element.TOTAL)
                            }
                        });

                        this.values.count = count
                        this.values.sales = sales
                        this.values.avista = avista
                        this.values.aprazo = aprazo
                    }
                })
                .catch(error => {
                    console.log('Error', '=>', error)
                })
        }
    },
    mounted(){
        this.getData()
    }
}
</script>